import { leftnavOptions } from "../layout/Leftnav/leftnavOptions";
// import { USER_ROLE } from "../constants/globalConstants";
// import { useAppSelector } from "../redux/store";

export const useLeftnavOptions = () => {
  // const { role } = useAppSelector((state) => state.auth);

  const filteredLeftnavOptions = leftnavOptions?.filter(
    (eachRoute) => eachRoute
  );
  return filteredLeftnavOptions;
};
